const properties = {
  /* NOTE: Data pf properties will be applied here from AppProps.json, so if u want to change any value change in AppProps.json file
	Not Here, Do not edit anything in this file*/
  isIntegrated: true
};

export const setProperties = config => {
  if (config) {
    for (const key in config) {
      properties[key] = config[key];
    }
  }
};

export default properties;
